import { helpers } from '@vuelidate/validators'

export const lettersOnlyValidator = helpers.withMessage(
  'Solo se permiten carácteres alfabéticos',
  (val?: string | null) => !val || /^[\p{L}\s]+$/u.test(val)
)
